import styled from 'styled-components';

const Logo = styled.img.attrs({
  src: '/configurator/cc53-11.png',
})`
  height: 45px;
  width: auto;

  @media (max-width: 1040px) {
    height: 20px;
  }
`;

export default Logo;
